<template>
  <el-dialog  class="developing_model_dialog" top="5vh" center
    :title="'缺陷-【' + formInfo.db_id + '】' + formInfo.db_title" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form ref="form" size="mini" :rules="rules" :model="formInfo">
      <el-form-item label="内容"  prop="db_context" :label-width="formLabelWidth" >
        <Editor   :content="formInfo.db_context"
                :dialogVisibleModelType="formInfo.db_id ? 'update' : 'create'" />
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="类型" :label-width="formLabelWidth">
          <div style="white-space: nowrap;"> {{formInfo.db_task_type}}</div>
        </el-form-item>
        <el-form-item label="严重程度" :label-width="formLabelWidth">
          <div style="white-space: nowrap;"> {{allSelect.BUGTASKPRIORITY[formInfo.db_severity]}}</div>
        </el-form-item>
        <el-form-item label="优先级" label-width="262px">
          <div style="white-space: nowrap;">{{formInfo.db_priority}}</div>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="关联任务" :label-width="formLabelWidth">
          <div style="white-space: nowrap;"> 【{{formInfo.db_related_task_id}}】{{formInfo.d_title}}</div>
        </el-form-item>
        <el-form-item label="负责人" label-width="137px">
          {{allSelect.TEXTALLUSERSEN[formInfo.db_leading]}}
        </el-form-item>
        <el-form-item label="系统" label-width="160px">
          <div style="white-space: nowrap;"> {{allSelect.TEXTMODULES[formInfo.db_module]}}</div>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="计划开始日期" label-width="220px">
          {{ formatTimeToDate(formInfo.db_plt * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item label="计划完成日期" label-width="150px">
          {{ formatTimeToDate(formInfo.db_plet * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item label="创建人" label-width="140px">
          <div style="white-space: nowrap;">{{allSelect.TEXTALLUSERSEN[formInfo.db_creator]}}</div>
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item label="创建时间" label-width="195px">
          <div style="white-space: nowrap;">{{ formatTimeToDate(formInfo.db_create_time * 1, "YYYY-MM-DD HH:mm:ss") }}</div>
        </el-form-item>
        <el-form-item label="状态" label-width="175px">
          {{ allSelect.BUGTASKSTATUS[formInfo.db_status] }}
        </el-form-item>
        <el-form-item label="是否确认为Bug" prop="db_is_bug" :label-width="formLabelWidth">
        <el-select size="mini"    v-model="formInfo.db_is_bug"  placeholder="请选择">
          <el-option   v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
        </el-select>
        </el-form-item>
      </div>
      <el-form-item label="处理内容"  prop="db_operator_context" :label-width="formLabelWidth" >
        <Editor   :content="formInfo.db_operator_context" @contentData="changeContent"
                 :dialogVisibleModelType="formInfo.db_id ? 'update' : 'create'" />
      </el-form-item>
      <el-form :model="formInfo" v-if="formInfo.db_id">
        <el-form-item class="comment_warp" label="评论" :model="formInfo" :label-width="formLabelWidth">
          <Comment  :tid="String(formInfo.db_id)" type="bug_task" />
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loading.toSave" @click="submit('save')">保存</el-button>
      <el-button type="warning" :loading="loading.toSave" @click="submit('sumbit')">提 交</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import {
  postDevOpsSpaceUpdateBugTaskApi,
  getDevOpsSpaceBugDetailApi
} from "@/server/tops/devOps";
import {
  formatDate,
  formatTimeToDate,
} from "@/views/tops/devOps/components/util.js";
import { mapState, mapMutations } from "vuex";
import Comment from '@/views/tops/devOps/producerSpace/components/comment.vue'
export default {
  components: { Editor, Comment },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
        id: "",
      },
      options: [{
        value: 0,
        label: '否'
      },
        {
          value: 1,
          label: '是'
        }],
      rules: {
        db_is_bug: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        db_operator_context: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: "200px",
      dialog: {

      },
      loading: {
        toSave: false,
      },
      is_admin: 0, // 0 不是管理员 1 是管理员
    };
  },
  async created() {
    await this.getOtherDetailApi();
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
  },
  updated() {
  },
  methods: {
    ...mapMutations(['setProgressBar', 'openWebSocket', 'sendWebSocket', 'closeWebSocket', 'scrollToBottom']),
    // 获取详情
    async getOtherDetailApi() {
      const { db_id = "" } = this.formInfo || {};
      try {
        const ret = await getDevOpsSpaceBugDetailApi({
          id: db_id,
        });
        const info = ret.data[0] || {};
        this.formInfo = {
          ...this.formInfo,
          db_title: info.db_title,
          db_context: info.db_context,
          db_create_time: info.db_create_time,
          db_leading: info.db_leading,
          db_module: info.db_module,
          db_operator_context: info.db_operator_context,
          db_plet: info.db_plet,
          db_plt: info.db_plt,
          db_priority: info.db_priority,
          db_related_task_id: info.db_related_task_id,
          db_severity: info.db_severity,
          db_status: info.db_status,
          db_task_type: info.db_task_type,
          project_system: info.project_system,
          db_creator: info.db_creator,
          db_is_bug: info.db_is_bug === 0 ? 1:info.db_is_bug,
        };
      } catch (error) {
        this.$notify({
          message: error || "获取详情失败",
          type: "error",
        });
      }
    },
    // 修改富文本内容
    changeContent(val) {
      this.formInfo.db_operator_context = val;
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step);
    },
    // 提交
    async submit(action) {
      this.$refs["form"].validate(async (valid) => {
        if(valid){
          const loginusername = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
          try {
            const {
              db_id = "",
              db_title = "",
              db_leading = "",
              db_creator = "",
              db_operator_context = "",
              db_is_bug = 0
            } = this.formInfo;


            const param = {
              id: db_id,
              leading: db_leading,
              creator: db_creator,
              username: loginusername,
              operator_context:db_operator_context,
              flag: action,
              title: db_title,
              is_bug:db_is_bug,
            };
            if(action == 'save'){
              delete param.creator
              delete param.title
            }
            const ret = await postDevOpsSpaceUpdateBugTaskApi(param);
            if (ret.status === 'success') {
              this.handleClose();
              this.$notify({
                message: ret.data?.msg || "提交成功",
                type: "success",
              });
            } else {
              this.$notify({
                message: ret.data?.msg || "提交失败",
                type: "error",
              });
            }
          } catch (error) {
            this.msg.toTestMsg = error || "数据错误";
          } finally {
            this.loading.toSave = false;
          }
        }
      })

    },
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.developing_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}

.developing_model_dialog_child {
  .el-dialog__body {
    padding: 0 20px 10px;
  }
}
.el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
  line-height: 16px;
}
</style>